import React from 'react';
import styled from 'styled-components';

const handleColorType = (module, theme) => {
	const moduleSection = module?.module;
	switch (moduleSection.toLowerCase()) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const CircleSVG = styled.svg`
	width: 18px;
	height: 18px;
	position: absolute;
	.circle-slash {
		fill: ${props => handleColorType(props.module, props.theme)};
	}
`;

export const CircleSlash = module => {
	return (
		<CircleSVG
			version='1.1'
			id='circle-slash'
			x='0px'
			y='0px'
			width='20.25px'
			height='20.25px'
			viewBox='0 0 28.25 28.25'
			module={module}
		>
			<g>
				<path
					className='circle-slash'
					d='M14.125,0C6.337,0,0,6.337,0,14.125S6.337,28.25,14.125,28.25S28.25,21.913,28.25,14.125S21.913,0,14.125,0z M4,14.125
		C4,8.542,8.542,4,14.125,4c2.251,0,4.325,0.747,6.009,1.994L5.993,20.134C4.747,18.45,4,16.376,4,14.125z M14.125,24.25
		c-2.251,0-4.326-0.748-6.011-1.995l14.141-14.14c1.247,1.684,1.995,3.759,1.995,6.01C24.25,19.708,19.708,24.25,14.125,24.25z'
				/>
			</g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
		</CircleSVG>
	);
};
